import React, { useState, createContext, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Cookies from 'js-cookie';

export const DataContext = createContext();

const DataProvider = (props: {}) => {
  const [expiry, setExpiry] = useState(new Date().getTime() + 600000);
  const [listSections, setListSections] = useState([]);
  const [searchParams, setsearchParams] = useSearchParams();
  const page: number | any = searchParams.get('page');
  const [isLoading, setisLoading] = useState(true);
  const [userInfo, setUserInfo] = useState({});
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
const Router =useNavigate()
  const [expire, setExpire] = useState(false);
  const [listSection, setListSection] = useState({});
  const [ValueForSearch, setValueForSearch] = useState({});
  const [titleSubInfo, setTitleSubInfo] = useState({
    ID: 0,
    Title: '',
    Parent_ID: 0,
    Definition: '',
    Code: '0',
    Ordering: 0,
    Type_ID: 0,
    Keywords: '',
    Old_IDs: '',
    MainLaw_IDs: '',
    Section_ID: 0,
    IsActive: false,
    isChecked: false,
  });
  const [RefreshCaptcha, setRefreshCaptcha] = useState(false);
  const [RegisterCaptcha, setRegisterCaptcha] = useState('');




  const [typeIdTitSub, setTypeIdTitSub] = useState([]);
  const [statusExeAndApr, setStatusExeAndApr] = useState([]);
  const [titSubParentID, setTitSubParentID] = useState(0);
  const [toggleSabt, setToggleSabt] = useState(true);
  const [ParentId, setParentId] = useState<null | Number>();
  // const [pIdChapter, setPIdChapter] = useState(null);
  const [pIdChapter, setPIdChapter] = useState(23);
  const [chapterSectionText, setChapterSectionText] = useState([]);
  const [executivSectionText, setExecutivSectionText] = useState([]);
  const [titChapterInfo, setTitChapterInfo] = useState({
    ID: 0,
    Title: '',
    Parent_ID: 0,
    Definition: '',
    Code: '0',
    Ordering: 0,
    Type_ID: 0,
    Keywords: '',
    Old_IDs: '',
    MainLaw_IDs: '',
    Section_ID: 0,
    IsActive: false,
    isChecked: false,
  });
  const [titSubID, setTitSubID] = useState({
    ID: 0,
    Title: '',
  });

  const [emptySearchText, setEmptySearchText] = useState(true);

  const [titExecutive, setTitExecutive] = useState({
    ID: 0,
    Parent_ID: 0,
    Title: '',
    dotic_ID: 0,
    CreateDate: '',
    ExpireDate: '',
    IsCategory: false,
    State_ID: 0,
    isForign: false,
    Domain: '',
    IsExecutor: false,
    PrevOrg_ID: 0,
    NextOrg_ID: 0,
    Comment: '',
    User_ID: 0,
    Ordering: 0,
    inActive: false,
    Report_ID: 0,
    TopLaws: '',
    TopTopic: '',
    Header: '',
    Icon: '',
  });

  const [toggleDToM, setToggleDToM] = useState(true);

  const [caseDataSpecialLaw, setcaseDataSpecialLaw] = useState({
    // date: jalaliFormat(new Date(), 'yyyy/MM/dd'),
    date: '',
    title: '',
    id: 0,
    ApprovalAuthority: null,
    lawtypeID: 0,
    typeID: 0,
    IsReplated: false,
    isChecked: null,
    ApproveDate2: '',
    ApproverID2: null,
  });

  const [caseData, setcaseData] = useState({
    ID: 0,
    reLaw_ID: 0,
    reSection_ID: 0 || null,
    Law_ID: 0,
    Section_ID: 0 || null,
    Status_ID: 0,
    isChecked: null,
    ExpireDate: '',
    FinalSectionText: '',
    ChangeText: '',
    withSub: false,
    description: '',
    sectionChangeID: null,
    TextOrder: null,
    TextOrder2: null,
  });
  const [ReformInfo, setReformInfo] = useState({
    ID: 0,
    Parent_ID: 0,
    Law_ID: 0,
    SectionText: '',
    Title: '',
    SectionType_ID: 0,
    TextOrder: 0,
    TextOrder2: 0,
    SectionNumber: 0,
    LetterNumber: '',
    SectionTitle: '',
    TextForEdit: '',
    RevisionRistrict: true,
    ChangeDate: '',
    Status: 0,
    SectionPath: '',
  });
  const [orgId, setOrgId] = useState(null);
  const [orgId2, setOrgId2] = useState(null);
  const [OptionSearch, setOption] = useState({
    value: 0,
    label: '',
  });
  const [listReSection, setListReSection] = useState([]);
  const [loading, setLoading] = useState(true);

  interface OrgItem {
    // id: number; // یا نوع مناسب دیگر
    // title: string; // یا نوع مناسب دیگر
    // // سایر ویژگی‌ها را اینجا اضافه کنید
    ID: number;
    Parent_ID: null;
    Item: string;
    Value: string;
    Category: number;
    Ordering: null;
  }

  type OrgType = OrgItem[]; // تعریف نوع آرایه

  const fetchTypeIdTitSub = async () => {
    // setLoading(true); // شروع بارگذاری
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Data/Get?id=10`,
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const org: OrgType = await response.json(); // تعیین نوع
      setTypeIdTitSub(org);
    } catch (error) {
      console.log('errorfetchTypeIdTitSub =>', error);
    } finally {
      // setLoading(false); // پایان بارگذاری
    }
  };

  const fetchStatusExeAndApr = async () => {
    // setLoading(true); // شروع بارگذاری
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Data/Get?id=7`,
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const statusEA: OrgType = await response.json(); // تعیین نوع
      // console.log('statusEA', statusEA);
      setStatusExeAndApr(statusEA);
    } catch (error) {
      console.log('errorfetchStatusExeAndApr =>', error);
    } finally {
      // setLoading(false); // پایان بارگذاری
    }
  };

  const ChangePassword = (obj: {}) => {
    // console.log(obj);
    fetch(`${process.env.REACT_APP_BASE_URL}/api/User/ChangePassword`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        'Content-Type': 'application/json',
      
      },
      body: JSON.stringify({
        // UserName: obj.userName,
        oldPassword: obj.oldPassword,
        newPassword: obj.password,
        confirmPassword: obj.confrimPassword,
      }),
    }).then((res) => {
      if (res.status == 200) {
        alert('عملیات با موفقیت انجام شد');
      } else {
      }
    });
  };

const [TextOrderListSection, setTextOrderListSection] = useState<
    null | object
  >({});



  const fetchListReSection = (id: number) => {
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/Admin/ListSection?search=${id}`,
    )
      .then((res) => res.json())
      .then((data) => setListReSection(data.data))
      .catch((error) => {})
      .finally(() => setLoading(false));
  };
  const fetchListSection = (id: number,itemID:number) => {
    // setLoading(true);
    try {
      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Admin/ListSection?search=${id}`,
      )
        .then((res) => res.json())
        .then((data) => {setListSections(data.data);setTextOrderListSection(data.data.find((r) => r.ID === itemID))})
        .finally(() => setLoading(false));
    } catch (error) {
      console.log('error', error);
    }
  };
  // console.log(listSections);
  // const token = localStorage.getItem('AccessToken');
  const [currentuserCookie, setCurrentUserCookie] = useState(null);

  const [tokenLogin, setTokenLogin] = useState(() => {
    if (typeof window !== 'undefined') {
      const storedValueToken = localStorage.getItem('tokenLogin');
      return storedValueToken ? JSON.parse(storedValueToken) : '';
    } else {
      return '';
    }
  });
  const [CookieToken, setCookieToken] = useState(() => {
    if (typeof window !== 'undefined') {
      const storedValueToken = Cookies.get('token');
      return storedValueToken ? JSON.parse(storedValueToken) : '';
    } else {
      return '';
    }
  });
  const fetchLoginJWT = async () => {
    setisLoading(true);
    localStorage.clear()
    try {
      // console.log(email, password);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Account/Login`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
           
          },
          body: JSON.stringify({
            UserName: `${username}`,
            Password: `${password}`,
          }),
        },
      );
      // console.log(response);
      const token = await response.json();
      // console.log(token);

      setisLoading(false);
      if (
        token[0] == 'Password : The Password field is required.' ||
        token[0] == 'user not found' ||
        token[0] == 'UserName : The UserName field is required.'
      ) {
        alert('نام ورود یا کلمه عبور اشتباه است، لطفا دوباره تلاش کنید.');
      } else {
        token.message!=="عملیات با موفقیت انجام شد"?alert(`${token.message}`):""
        setTokenLogin(token);
        const decode = jwtDecode(token.data?.accessToken);
        localStorage.setItem('username', decode.userName);
        // setEdame(true);
        window.location.assign('/home');
        console.log('token Is True');
      }
    } catch (error) {
      console.log('errorFetchLoginJWT', error);
    }
   
  };
  const FetchLoginLawMinerPlus = async () => {
    setLoading(true);
    try {
      // console.log(email, password);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/Account/Login`,
        // `${process.env.REACT_APP_BASE_URL}/api/Account/Login`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            userName: `${username}`,
            password: `${password}`,
          }),
        },
      );
      
      const token = await response.json();
      setLoading(false);
      if (token.statusCode !== 200) {
        alert('نام ورود یا کلمه عبور اشتباه است، لطفا دوباره تلاش کنید.');
        setRefreshCaptcha(true)
      } else {
        Cookies.set('token', `${JSON.stringify(token.data)}`, {
          domain: '.ilaws.net' | '.localhost' | '.85.198.9.88',
          Secure: true,
          path: '/',
          sameSite: 'strict',
        });
        const cookietoken = JSON.parse(Cookies.get('token'));
        console.log('tokenContext', cookietoken);
        setCookieToken(cookietoken);
        setCurrentUserCookie(jwtDecode(cookietoken?.accessToken));
        fetchLoginJWT();
      }
    } catch (error) {
      console.log('errorFetchLoginPRofile', error);
    }
  };

  const expireToken = (tokenProp) => {
    try {
      const decoded = jwtDecode(tokenProp);
      if (decoded.exp < Date.now() / 1000) {
        localStorage.setItem('tokenexpire', JSON.stringify(true));
        setExpire(true);
        return true;
      } else {
        localStorage.setItem('tokenexpire', JSON.stringify(false));
        setExpire(false);
        return false;
      }
    } catch (err) {
      return false;
    }

  };
  const isTokenExpired = (tokenProp) => {
    try {
      const decoded = jwtDecode(tokenProp);
      // console.log(decoded.exp < Date.now() / 1000);
      if (decoded.exp < Date.now() / 1000) {
        return true;
      } else return false;
    } catch (err) {
      return false;
    }
  };

  const fetchRefreshToken = async () => {
    console.log(
      'username',
      JSON.stringify(`${jwtDecode(tokenLogin.data?.accessToken).userName}`),
    );
    // console.log('token', JSON.stringify(`${tokenLogin?.RefreshToken}`));
    setisLoading(true);
    // if (tokenLogin.data?.accessToken) {
    try {
      // const Username = jwtDecode(tokenLogin.data?.accessToken).userName;
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Accounts/RefreshToken`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
            'Access-Control-Allow-Headers':
              'X-Requested-With, Content-Type, Authorization',
            'Access-Control-Allow-Credentials': 'true',
          },
          body: JSON.stringify({
            Token: `${tokenLogin.data?.refreshToken}`,
            UserName: `${jwtDecode(tokenLogin.data?.accessToken).userName}`,
          }),
        },
      );
      if (response.status === 200) {
        // console.log(response);
        const token = await response.json();
        setTokenLogin(token);
        // setEdame(true);
        localStorage.setItem('tokenLogin', JSON.stringify(token));
        // localStorage.setItem('edame', JSON.stringify(true));
        setisLoading(false);
        // alert("")
      } else {
        // console.log('error', response);
        // setEdame(false);
        setTokenLogin('');
        localStorage.setItem('tokenLogin', JSON.stringify(''));
        // localStorage.setItem('edame', JSON.stringify(false));
        window.location.assign('/');
      }
    } catch (error) {
      console.log('errorFetchRefreshToken', error);
      // setEdame(false);
    }
    // }
  };
  const NewfetchRefreshToken = async () => {
  
    setisLoading(true);
    
    try {
    
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/Account/RefreshTokenRegeneration`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            Token: `${CookieToken.refreshToken}`,
            UserName: `${jwtDecode(CookieToken.accessToken).userName}`,
          }),
        },
      );
      const token = await response.json();
      if (token.statusCode === 200) {
        Cookies.set('token', `${JSON.stringify(token.data)}`, {
          domain: '.ilaws.net' | '.localhost',
          Secure: true,
          path: '/',
          sameSite: 'strict',
        });
        const cookietoken = JSON.parse(Cookies.get('token'));
        console.log('tokenContext', cookietoken);
        setCookieToken(cookietoken);
        setCurrentUserCookie(jwtDecode(cookietoken?.accessToken));
        setisLoading(false);
      } else {
        setTokenLogin('');
        Cookies.remove('token');
        window.location.assign('/');
      }
    } catch (error) {
      console.log('errorFetchRefreshToken', error);
      // setEdame(false);
    }
    // }
  };
const [CodeGozari, setCodeGozari] = useState([]);
  const fetchCodeGozari = async () => {
    setLoading(true);
    try {
      const CodeGozari = await (
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/BaseInfo?cat=5`, {
          headers: {
            "Content-Type": "application/json",
      
          },
        })
      ).json();
      setCodeGozari(CodeGozari);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log('errorfetchCodeGozari =>', error);
    }
  };


  const [TypeIDList, setTypeIDList] = useState([]);
  const FetchDAta = () => {
    fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/Get?id=1`)
      .then((res) => res.json())
      .then((data) => setTypeIDList(data));
  };

  useEffect(() => {
    // if (isTokenExpired(tokenLogin.data?.accessToken)) {
    //   if (!isTokenExpired(tokenLogin?.RefreshToken)) {
    //     // setEdame(false);
    //     // localStorage.setItem('edame', JSON.stringify(false));
    //     fetchRefreshToken();
    //   }
    // }
    FetchDAta();
  }, [page]);

  useEffect(() => {
    fetchTypeIdTitSub();
    fetchStatusExeAndApr();
    return () => {};
  }, []);

  const Register = (obj: {}) => {
    // console.log(obj);
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/Account/Register`,

      headers: {
        // Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        'Content-Type': 'application/json',
      
      },
      data: JSON.stringify({
        UserName: obj.Username,
        Email: obj.email,
        Password: obj.Password,
        ConfirmPassword: obj.confirmPassword,
        FirstName: obj.firstName,
        LastName: obj.lastName,
      }),
    };
    // console.log(obj);
    if (obj.Password === obj.confirmPassword) {
      axios
        .request(config)
        .then((res) => {
          if (res.status == 200) {
            alert('کاربر با موفقیت ثبت نام شد ');
            // navigate('/');
          } else {
            // console.log(res);
            console.log(res);
          }
        })
        // fetch(`${process.env.REACT_APP_BASE_URL}/api/Accounts/Register`, {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify({
        //     UsernName: obj.Username,
        //     Email: obj.Email,
        //     Password: obj.Password,
        //     ConfirmaPassword: obj.confirmPassword,
        //     FirstName: obj.firstName,
        //     LastName: obj.lastName
        //   }),
        // })
        // axios({
        //   method: "post",
        //   url: `https://apilaw.mrc.ir:8080/api/Accounts/Register`,
        //   data: JSON.stringify({
        //     UsernName: obj.Username,
        //     Email: obj.Email,
        //     Password: obj.Password,
        //     ConfirmaPassword: obj.confirmPassword,
        //     FirstName: obj.firstName,
        //     LastName:obj.lastName
        //   }),
        //     headers: {
        //       "Content-Type": "application/json ",
        //     },
        //     })
        .then(function (response) {
          if (response) {
            //   localStorage.setItem('AccessToken',response.data.AccessToken)
            // localStorage.setItem('refresh', response.data.RefreshToken)
            // window.location.reload()
            // window.location.assign('/')
            // console.log('response', response);
          }
        })
        .catch(function (error) {
          if (error) {
            // localStorage.removeItem('AccessToken')
            //   localStorage.removeItem('refresh')
            //     window.location.assign("/")
            console.log('error', error);
          }
        });
    } else {
      alert('پسورد را تایید کنید');
    }
  };

  const Logout = () => {
    
    localStorage.clear();
    Cookies.remove('token')
    window.location.assign('/');
  };

  const checkEdame = () => {
    if (isTokenExpired(tokenLogin.data?.accessToken)) {
      if (isTokenExpired(tokenLogin.data?.refreshToken)) {
        // setEdame(false);

        console.log('edame false');

        // localStorage.setItem('edame', JSON.stringify(edame));
      } else {
        console.log('edame with refreshToken');

        fetchRefreshToken();
      }
    } else {
      try {
        console.log('check edame true ');

        // localStorage.setItem('edame', JSON.stringify(edame));
      } catch (error) {
        console.log('errorFetchAllData222222222222', error);
      }
    }
  };
  const [TypeList, setTypeList] = useState([]);
  const [openEdiModal, setOpenEditModal] = useState(false);
  const [OpenCreateModal, setOpenCreateModal] = useState(false);
  const [openDeleteModalReform, setOpenDeleteModalReform] = useState(false);
  const [Lops, setLops] = useState([]);

  const [deleteID, setDeleteID] = useState(0);

  const fetchLops = async (id: number) => {
    try {
      await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Admin/ListSection?search=${id}`,
        {
          headers: {
            Authorization: `Bearer ${tokenLogin?.AccessToken}`,
          },
        },
      )
        .then((res) => res.json())
        .then((data) => setLops(data.data))
        .finally(() => setLoading(false));
    } catch (error) {
      console.log('error', error);
    }
  };

  const ReFormEditFun = async () => {
    console.log(ReformInfo.SectionText);
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/Admin/EditSection?ID=${ReformInfo.ID}&Law_ID=${ReformInfo.Law_ID}&Parent_ID=${ReformInfo.Parent_ID}&Title=${ReformInfo.Title}&SectionType_ID=${ReformInfo.SectionType_ID}&TextOrder=${ReformInfo.TextOrder}&SectionNumber=${ReformInfo.SectionNumber}&LetterNumber=${ReformInfo.LetterNumber}`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        'Content-Type': 'application/json',
        
      },
      data: JSON.stringify(ReformInfo.SectionText),
    };

    if (!isTokenExpired(tokenLogin.data?.accessToken)) {
      // console.log('check');
      await axios.request(config).then((response) => {
        // console.log(response);
        if (response.status == 200) {
         
          setOpenEditModal(false);
          alert('با موفقیت ویرایش شد');
     
        } else {
          fetchRefreshToken();
        }
      });
    } else {
      fetchRefreshToken();
    }
  };
    const [Roles, setRoles] = useState([]);
    const[RoleCount,setRoleCount]=useState(0)

  const GetRolesList = () => {
    let config = {
      method: 'post',
      // maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/api/Role/RoleList`,
      // url: `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/Role/RoleList`,
      headers: {
        // Authorization: `Bearer ${CookieToken.accessToken}`,
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        filters: {
          pageNumber: 1,
          pageSize: 20,
          isSortAscending: true,
          sortField: '',
          search: '',
        },
        name: '',
        projectName: '',
        description: '',
        // isActive: true,
      }),
    };
    setLoading(true);
    try {
      axios.request(config).then((res) => {
        const list = res.data;
        // console.log(list.data);
        setRoles(list.data.items);
        setRoleCount(list.data.totalItems)
        setLoading(false)
      });
    } catch (error) {}
  };

const [permissionId,setPermissionId]=useState()

  
  return (
    <DataContext.Provider
      value={{
        // pageCount,
        // isLoading,
        // fetchPage
        fetchLops,
        ReFormEditFun,
        openEdiModal,
        setOpenEditModal,
        OpenCreateModal,
        setOpenCreateModal,
        openDeleteModalReform,
        setOpenDeleteModalReform,
        deleteID,
        setDeleteID,
        Lops,
        setLops,

        setUserInfo,
        userInfo,
        setUserName,
        setPassword,
        username,
        password,
        // login,
        expire,
        Register,
        Logout,
        // token,
        expireToken,
        listSection,

        fetchLoginJWT,
        tokenLogin,
        setTokenLogin,
        expiry,
        setExpiry,
        checkEdame,
        isTokenExpired,
        fetchRefreshToken,
        caseData,
        setcaseData,
        ReformInfo,
        setReformInfo,
        OptionSearch,
        setOption,
        orgId,
        setOrgId,
        orgId2,
        setOrgId2,
        isLoading,
        setisLoading,
        ValueForSearch,
        setValueForSearch,
        TypeList,
        setTypeList,
        fetchListReSection,
        loading,
        setLoading,
        listReSection,
        setListReSection,
        fetchListSection,
        listSections,
        setListSections,
        TypeIDList,
        setTypeIDList,

        // listSections,
        // setListSections,

        titleSubInfo,
        setTitleSubInfo,
        titSubParentID,
        setTitSubParentID,

        typeIdTitSub,
        setTypeIdTitSub,

        titSubID,
        setTitSubID,
        ChangePassword,
        // AddRole,
        // DeleteRole,
        titExecutive,
        setTitExecutive,

        toggleDToM,
        setToggleDToM,

        executivSectionText,
        setExecutivSectionText,
        statusExeAndApr,
        setStatusExeAndApr,

        toggleSabt,
        setToggleSabt,

        pIdChapter,
        setPIdChapter,
        titChapterInfo,
        setTitChapterInfo,
        chapterSectionText,
        setChapterSectionText,

        emptySearchText,
        setEmptySearchText,
        ParentId,
        setParentId,
        caseDataSpecialLaw,
        setcaseDataSpecialLaw,

        currentuserCookie,
        setCurrentUserCookie,
        CookieToken,
        setCookieToken,
        FetchLoginLawMinerPlus,
        GetRolesList,
        Roles, setRoles,
        TextOrderListSection, setTextOrderListSection,
        NewfetchRefreshToken,CodeGozari, setCodeGozari,fetchCodeGozari,
        RefreshCaptcha, setRefreshCaptcha,RegisterCaptcha, setRegisterCaptcha,permissionId,setPermissionId,RoleCount,setRoleCount
   
  
      }}
    >
      {props.children}
    </DataContext.Provider>
  );
};

export default DataProvider;
